import { useState } from 'react';
import Card from 'react-bootstrap/Card';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Link } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import Toggle from '../Toggle';

function Item(data, isPreview){
  let {title, img, id, url, role, description, takeaway} = data;
  const [isDemo, setIsDemo] = useState(isPreview);
  img = isDemo ? img.preview : img.full
  function ImageDisplay(){
    return(isDemo ?
      <div className="image">
        <img className='img-fluid w-100' src={img} alt={title}/>
        <div className="info">
          <span className="category">{title}</span>
        </div> 
        <Toggle isChecked={isDemo} handleChange={()=>setIsDemo(!isDemo)} labelContent={""} target={id+"-project"}></Toggle>
      </div> 
      : 
      <Card className='project-full ratio-16x9'>
        <Toggle isChecked={isDemo} handleChange={()=>setIsDemo(!isDemo)} labelContent={""} target={id+"-project"}></Toggle>
        <Card.Body className='scroll-container '>
          <div className="image">
            <img className='img-fluid w-100' src={img} alt={title}/>
            <div className="info">
              <span className="category">{title}</span>
            </div> 
            
          </div>
            <div className="info">
              <span className="category">{title}</span>
            </div> 
            <Card.Header><h3>{role}</h3></Card.Header>
            <Card.Text>{description}</Card.Text>
            <Card.Text>{takeaway}</Card.Text>
            {/* <Button>
              Email
            </Button>
            <Button variant="secondary">
              Github
            </Button> */}
        </Card.Body>
      </Card>   
    )
  }
  return(
    <div className="project-item">
      <ImageDisplay/>                  
    </div>
  )
}
const ProjectCols = (props)=>{
  const projects = {
    sapling:{
      title: "Sapling", img: {
        preview: "assets/img/game/sapling-cover.png",
        full: "assets/img/game/sapling-cover.png"
      },
      id:"sapling",
      url:"https://jordanralba.itch.io/sapling",
      role:"Lead Developer",
      description:"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur venenatis metus augue, et sagittis leo iaculis eget. Sed nec imperdiet turpis, a dignissim metus. Nam eget nibh quis felis fringilla pulvinar nec non mi. Sed efficitur, nibh ut mattis rhoncus, diam tellus aliquam ligula, sed ornare nibh felis quis massa. Integer id sollicitudin felis, eget placerat ante. Nam elementum augue et risus imperdiet varius. Suspendisse potenti.",
      takeaway:"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur venenatis metus augue, et sagittis leo iaculis eget. Sed nec imperdiet turpis, a dignissim metus. Nam eget nibh quis felis fringilla pulvinar nec non mi. Sed efficitur, nibh ut mattis rhoncus, diam tellus aliquam ligula, sed ornare nibh felis quis massa. Integer id sollicitudin felis, eget placerat ante. Nam elementum augue et risus imperdiet varius. Suspendisse potenti.",
    },
    staticPortfolio:{
      title: "Static Portfolio", img: {
        preview: "assets/img/webpage/static_portfolio-home.png",
        full: "assets/img/webpage/static_portfolio-home.png"
      },
      id:"static-portfolio",
      url:"https://jordanralba.dev/",
      role:"",
      description:"",
      takeaway:"",
    },
    airodigitalCustomerPortal:{
      title: "AiroDigital Customer Portal", img: {
        preview: "assets/img/webpage/airodigital_customer_portal-home.png",
        full: "assets/img/webpage/airodigital_customer_portal-home.png"
      },
      id:"customer-portal",
      url:"",
      role:"",
      description:"",
      takeaway:"",
    },
    chessChallenge:{
      title: "Chess Challenge", img: {
        preview: "assets/img/webpage/chess_challenge-home.png",
        full: "assets/img/webpage/chess_challenge-home.png"
      },
      id: "chess",
      url:"https://jordanralba.github.io/Coding-Challenges/",
      role:"",
      description:"",
      takeaway:"",
    },
    financeTracker:{
      title: "Student Finance Tracker", img: {
        preview:"assets/img/webpage/finance_tracker-home.png",
        full:"assets/img/webpage/finance_tracker-home.png",
      },
      id: "finance-tracker",
      url:"https://jordanralba.github.io/BSU-personal-finances/",
      role:"Lead Developer/Project Manager",
      description:"",
      takeaway:"",
    },
    tmobileMemo:{
      title: "T-Mobile Memo Generator", img: {
        preview:"assets/img/webpage/tmobile_memo-home.png",
        full:"assets/img/webpage/tmobile_memo-home.png"
      },
      id:"tmobile-memo",
      url:"",//"https://jordanralba.github.io/TMobile-Memo/",
      role:"Lead Developer/Project Manager",
      description:"",
      takeaway:"",
    },
    crudApi:{
      title: "CRUD Rest API", img: {
        preview:"assets/img/webpage/crud_api-home.png",
        full:"assets/img/webpage/crud_api-home.png"
      },
      id:"crud-api",
      url:"https://gimm-crud-5dd49d64388a.herokuapp.com/",
      role:"",
      description:"",
      takeaway:"",
    },
    spiderAnimation:{
      title: "Blender Spider Animation", img: {
        preview:"assets/img/animation/spider_animation.png",
        full:"assets/img/animation/spider_animation.png"
      },
      id:"spider-animation",
      url:"https://www.youtube.com/embed/rkO2_QMHznM?si=ZC9X1mhllzeAjut_",
      role:"",
      description:"",
      takeaway:"",
    },
    portalGun:{
      title: "Rick and Morty Portal Gun", img: {
        preview:"assets/img/animation/portal_gun.png",
        full:"assets/img/animation/portal_gun.png"
      },
      id:"portal-gun",
      url:"https://www.youtube.com/embed/abCC_4ARDBQ?si=JD07YAA8EN5m8-Gi",
      role:"",
      description:"",
      takeaway:"",
    },
  }
  switch(props.showAll){
    case false : {
      return (<>
        <Col lg={12} >{Item(projects.sapling, true)}</Col>
        <Col lg={12} >{Item(projects.financeTracker, true)}</Col>
      </>)
    }
    case true : {
      return (<>
        <Col lg={12} >{Item(projects.sapling, true)}</Col>
        <Col lg={12} >{Item(projects.financeTracker, true)}</Col>
        <Col lg={12} >{Item(projects.crudApi, true)}</Col>
        <Col lg={12} >{Item(projects.chessChallenge, true)}</Col>
        <Col lg={12} >{Item(projects.tmobileMemo, true)}</Col>
        <Col lg={12} >{Item(projects.staticPortfolio, true)}</Col>
        <Col lg={12} >{Item(projects.airodigitalCustomerPortal, true)}</Col>
        <Col lg={12} >{Item(projects.spiderAnimation, true)}</Col>
        <Col lg={12} >{Item(projects.portalGun, true)}</Col>
      </>)
    }
  }
}
function Project(props) {
  switch(props.showAll){
    case true:{
      return (
        <Card className='project-card content-card'>
          <Card.Body>
            <div className='card-info'>
              <Card.Title as="h1">Check Out My Latest 
                <span>&nbsp;Projects</span>
              </Card.Title>
              <p className='card-subtext'>
                I'm here to help! Whether you're searching for a technical designer/developer to help bring your idea to life or a design partner take your project to the next level.
              </p>
            </div>
            
            <div className='scroll-container project-container'>
              <Row className='g-5'>
                <ProjectCols showAll={props.showAll}/>
              </Row>
            </div>
          </Card.Body>
        </Card>
      );
    }
    case false:{
      return (
        <Card className='project-card'>
          <Card.Body>
            <Card.Title as="h3">Recent Projects
            <Link to='/projects' className="link-btn">
              All Projects <span data-icon="arrow"></span>
            </Link>
            </Card.Title>
            <div className='project-container'>
              <Row className='g-4'>
                <ProjectCols showAll={props.showAll}/>
              </Row>
            </div>
          </Card.Body>
        </Card>
      );
    }
  }
}

 export default Project;